import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import CssClass from "../../Styles/common.module.css";
import http from "../../common/http-common";
import { GetPagePermissionFn } from "../../common/authority";
import search from "../../assets/search-icon.png";
import clear from "../../assets/blackClear-icon.png";
import exportIcon from "../../assets/export-icon.png";
import { useEffect, useState } from "react";
import { components } from "react-select";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PAGE_NAME = "AgentKPI.js_";
const MODULE_ID = "WEB_DASH_002";

const AgentKPI = (props) => {
  document.title = common.c_TITLE + " - Agent KPI";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [dataToBeSelect, setDataToBeSelect] = useState({
    Company: [],
    System: [],
    Agent: [],
  });

  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);
  const [inputError, setInputError] = useState([]);

  const [companyData, setCompanyData] = useState([]);
  const [company, setCompany] = useState([]);
  const [systemData, setSystemData] = useState([]);
  const [system, setSystem] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [agent, setAgent] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedSystem, setSelectedSystem] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [allUsers, setAllUsers] = useState([]);
  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  const colorPalette = [
    "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#F38630",
    "#CECECE", "#00A8C6", "#AAF0D1", "#EEE8AA", "#6A4A3C", "#C44D58",
    "#556270", "#B3D9D9", "#C7F464", "#FF6B6B", "#C44D58", "#C7C7C7"
  ];

  const userColorMap = {};
  let colorIndex = 0;

  Object.values(allData).forEach((systemData) => {
    systemData.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key !== "TICKET_STATUS_TYPE_NAME" && !userColorMap[key]) {
          userColorMap[key] = colorPalette[colorIndex % colorPalette.length];
          colorIndex++;
        }
      });
    });
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "useEffect Get Agent KPI";
  
      try {
        onLoadingHandler(true, "Getting Agent KPI, please wait...");
        setAllData([]);
  
        const companySelected = Array.isArray(company)
          ? company.map(r => r.key)
          : company?.key ? [company.key] : [];
        const systemSelected = system?.map(r => r.key) || [];
        const agentSelected = agent?.map(r => r.key) || [];
  
        let newStartDate = "", newEndDate = "";
        if (startDate !== null) newStartDate = common.c_Dis_DateTime(startDate).val;
        if (endDate !== null) newEndDate = common.c_Dis_DateTime(endDate).val;
  
        http
          .get(
            `api/agentkpi/GetAgentKPI?_org=${companySelected}&_system=${systemSelected}&_agent=${agentSelected}&_startDate=${newStartDate}&_endDate=${newEndDate}`,
            { timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              const fixedStatuses = ["ACKNOWLEDGE", "RESOLVED", "VERIFIED", "CLOSED", "CANCEL"];
              const groupedSystemMap = new Map();
              const allUsers = new Set();
  
              response.data.forEach(({ USER_SHORT_NAME }) => allUsers.add(USER_SHORT_NAME));
  
              response.data.forEach((data) => {
                const { SYSTEM_MST_NAME: system, TICKET_STATUS_TYPE_NAME: status, USER_SHORT_NAME: user } = data;
  
                if (!groupedSystemMap.has(system)) {
                  groupedSystemMap.set(system, new Map());
                }
  
                const ticketMap = groupedSystemMap.get(system);
  
                if (!ticketMap.has(status)) {
                  ticketMap.set(status, { TICKET_STATUS_TYPE_NAME: status });
                }
  
                const ticketData = ticketMap.get(status);
                ticketData[user] = (ticketData[user] || 0) + 1;
              });
  
              const finalData = {};
              groupedSystemMap.forEach((ticketMap, systemName) => {
                const systemData = [];
  
                fixedStatuses.forEach((status) => {
                  const base = { TICKET_STATUS_TYPE_NAME: status };
                  allUsers.forEach(user => {
                    base[user] = ticketMap.get(status)?.[user] || 0;
                  });
                  systemData.push(base);
                });
  
                finalData[systemName] = systemData;
              });
  
              setAllData(finalData);
              setAllUsers(Array.from(allUsers));
              console.log("Chart Data:", finalData);
            }
          })
          .catch((err) => {
            toast.error("Error on getting agent KPI. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting agent KPI. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId, props.response]);
  

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      setCompanyData([]);
      const listItems = [];

      try {
        functionName = "useEffect Get Company List";
        onLoadingHandler(true, "Getting Company List, please wait...");

        http
          .get("api/agentkpi/GetCompanyList?_user=" + userId, { timeout: 10000 })
          .then((response) => {
            if (response.data.length > 0) {
                response.data.forEach((data, counter) => {
                    listItems.push({
                        key: data.ORG_ID,
                        value: data.ORG_ID,
                        label: data.ORG_NAME,
                    });
                });
                setCompanyData(listItems);
            }
          })
          .catch((err) => {
            toast.error("Error on getting company list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting company list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [actionAuthority, userId]);

  useEffect(() => {
      let functionName = "";

      setSystemData([]);
      const listItems = [];   
      const companySelected = selectedCompany.map(company => company.value);

      try {
        functionName = "useEffect Get System List";
        onLoadingHandler(true, "Getting System List, please wait...");

        http
          .get("api/agentkpi/GetSystemList?_userId=" + userId + "&_orgId=" + companySelected, { timeout: 10000 })
          .then((response) => {
            if (response.data.length > 0) {
                response.data.forEach((data, counter) => {
                    listItems.push({
                        key: data.SYSTEM_MST_ID,
                        value: data.SYSTEM_MST_ID,
                        label: data.SYSTEM_MST_NAME,
                    });
                });
                setSystemData(listItems);
            }
          })
          .catch((err) => {
            toast.error("Error on getting system list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting system list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [selectedCompany, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
        setAgentData([]);
        const listItems = [];
  
        try {
            http
            .get("api/agentkpi/GetAgentList?_userId=" + userId, { timeout: 10000000 })
            .then((response) => {
                if (response.data.length > 0) {
                    response.data.forEach((data, counter) => {
                        listItems.push({
                            key: data.USER_ID,
                            value: data.USER_ID,
                            label: data.USER_SHORT_NAME,
                        });
                    });
                    setAgentData(listItems);
                }
            })
            .catch((err) => {
                toast.error("Error on getting agent list. Please try again.1");
                common.c_LogWebError(PAGE_NAME, err.stack);
            })
        } catch (err) {
            toast.error("Error on getting agent list. Please try again.");
            common.c_LogWebError(PAGE_NAME, err.stack);
        }
      }
  }, [actionAuthority, userId]);

  //#region Export Excel
  // const onExcelHandler = () => {
  //   const systemSelected =
  //   systemData !== undefined && Object.keys(systemData).length !== 0
  //       ? systemData.map((r) => r.key)
  //       : "";

  //   window.open(
  //     // common.c_getApiUrl() +
  //     //   "api/users/ExportExcel?_userId=" +
  //     //   userIdSelected +
  //     //   "&_role=" +
  //     //   roletypeSelected +
  //     //   "&_user=" +
  //     //   userId
  //     common.c_getApiUrl() +
  //       "api/users/ExportExcel?system=" +
  //       systemSelected
  //   );
  // };
  //#endregion

  //#region Event Handlers
  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const onClearHandler = () => {
    setSelectedCompany([]);
    setSelectedSystem([]);
    setSelectedAgent([]);
    setDateRange([null, null]);
  };

  const selectCompanyHandler = (val) => {
    let functionName = "";
    try {
        functionName = selectCompanyHandler.name;
  
        if (Object.keys(val).length > 0) {
          setInputError((prevState) => ({
            ...prevState,
            COMPANY: "",
          }));
        }
        setCompany(val)
        setSelectedCompany(val)
        setSelectedSystem([]);
  
    } catch (err) {
        common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }
  
  const selectSystemHandler = (val) => {
    let functionName = "";
    try {
      functionName = selectSystemHandler.name;
  
      if (Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          SYSTEM: "",
        }));
      }
      setSystem(val)
      setSelectedSystem(val)
  
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

  const selectAgentHandler = (val) => {
    let functionName = "";
    try {
      functionName = selectAgentHandler.name;

      if (Object.keys(val).length > 0) {
          setInputError((prevState) => ({
            ...prevState,
            AGENT: "",
          }));
      }
      setAgent(val)
      setSelectedAgent(val)

    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }
  //#endregion

  return (
    <>
      <Comp.Header>Agent KPI</Comp.Header>

      <Comp.SearchPanel onSubmit={onReloadHandler}>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Company</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
                id="Company"
                options={companyData}
                closeMenuOnSelect={true}
                isClearable={true}
                value={selectedCompany}
                hideSelectedOptions={false}
                onChange={selectCompanyHandler}
                isMulti
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>System</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
                id="System"
                options={systemData}
                closeMenuOnSelect={true}
                isClearable={true}
                value={selectedSystem}
                hideSelectedOptions={false}
                onChange={selectSystemHandler}
                isMulti
            />
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Agent</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
                id="Agent"
                options={agentData}
                closeMenuOnSelect={true}
                isClearable={true}
                value={selectedAgent}
                hideSelectedOptions={false}
                onChange={selectAgentHandler}
                isMulti
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Ticket Created Date</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.DateTimePicker
                selectsRange
                onChange={(dates) => setDateRange(dates)}
                startDate={startDate}
                endDate={endDate}
            />
          </td>
        </tr>
      </Comp.SearchPanel>
      <div className={CssClass.btnWrapper}>
        <Comp.Button id="btnSearch" type="general" onClick={onReloadHandler}>
          SEARCH  <img src={search} alt="Search" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
        {/* <Comp.Button id="btnClear" type="clear" onClick={onClearHandler}>
          CLEAR  <img src={clear} alt="Search" style={{ width: "18px", height: "18px", marginBottom: "2px" }} />
        </Comp.Button> */}
        {/* <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button> */}
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {Object.entries(allData).map(([systemName, data]) => {
          const fixedStatusOrder = ["ACKNOWLEDGE", "RESOLVED", "VERIFIED", "CLOSED", "CANCEL"];

          const statusMap = new Map();
          const userTotalCount = {};

          data.forEach(item => {
            const { TICKET_STATUS_TYPE_NAME, ...users } = item;
            if (!statusMap.has(TICKET_STATUS_TYPE_NAME)) {
              statusMap.set(TICKET_STATUS_TYPE_NAME, {});
            }

            Object.entries(users).forEach(([user, count]) => {
              const statusUsers = statusMap.get(TICKET_STATUS_TYPE_NAME);
              statusUsers[user] = count;

              userTotalCount[user] = (userTotalCount[user] || 0) + count;
            });
          });

          const filteredUsers = Object.keys(userTotalCount).filter(user => userTotalCount[user] > 0);

          const chartData = fixedStatusOrder.map(status => {
            const entry = { TICKET_STATUS_TYPE_NAME: status };
            const users = statusMap.get(status) || {};

            filteredUsers.forEach(user => {
              entry[user] = users[user] || 0;
            });

            return entry;
          });

          return (
            <div 
              key={systemName} 
              style={{ 
                marginBottom: "40px", 
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <h3 style={{ textAlign: "center", marginBottom: "20px" }}>{systemName}</h3>
              <div style={{ display: "block", marginLeft: "70px" }}>
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={chartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="TICKET_STATUS_TYPE_NAME" 
                    tick={{ 
                      style: { fontWeight: 'bold' } 
                    }} 
                  />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  {/* <Legend /> */}
                  {filteredUsers.map(user => (
                    <Bar
                      key={user}
                      dataKey={user}
                      fill={userColorMap[user]}
                      name={user}
                    />
                  ))}
                </BarChart>
              </ResponsiveContainer>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead style={{ display: "none" }}>
                  <tr>
                    <th></th>
                    {fixedStatusOrder.map(status => (
                      <th key={status}>
                        {status}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.map(user => (
                    <tr key={user}>
                      <td style={{ border: "1px solid #ccc", padding: "8px", width: "105px" }}>
                        <span
                          style={{
                            display: "inline-block",
                            width: "10px",
                            height: "10px",
                            backgroundColor: userColorMap[user],
                            marginRight: "8px",
                          }}
                        ></span>
                        {user}
                      </td>
                      {fixedStatusOrder.map(status => {
                        const statusData = chartData.find(d => d.TICKET_STATUS_TYPE_NAME === status);
                        const count = statusData ? statusData[user] || 0 : 0;
                        return (
                          <td
                            key={status}
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              textAlign: "center", 
                              width: "200px"
                            }}
                          >
                            {count}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default AgentKPI;
